<template>
  <div>
    <page-container :title="breadcrumb" :breadcrumb="breadcrumb">
      <div class="bg-white">
        <div class="main-container" style="margin-top: -15px">
          <div class="title">平台使能参数</div>
        </div>
      </div>
      <div>
        <a-tabs default-active-key="1" style="background-color: white" @change="callback">
          <a-tab-pane key="1" tab="区域使能列表">
            <div class="main-container">
              <div class="list-table">
                <div class="table-header">
                  <h3 class="table-title">区域使能参数</h3>
                  <div class="table-btns">
<!--                    <a-button type="primary" @click="" style="margin-right: 10px">批量配置</a-button>-->
                    <a-icon type="redo" class="after-btn table-refresh" style="float: right;margin-right: 1%;font-size: 20px;margin-bottom: 5px" @click="getTableData(true)"></a-icon>
                  </div>
                </div>
                <a-table :columns="tableColumns" :data-source="tableData" row-key="paramsid" :loading="tableLoading" :row-class-name="(record, index) => (index%2==0?'table-row-even':'table-row-single')" style="margin-top: 20px;" :pagination="false">
                  <span slot="rescueable" slot-scope="value">
                    <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'使能':'禁用'}}</a-tag>
                  </span>
                  <span slot="apporderable" slot-scope="value">
                    <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'使能':'禁用'}}</a-tag>
                  </span>
                  <span slot="messageable" slot-scope="value">
                    <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'使能':'禁用'}}</a-tag>
                  </span>
                  <span slot="alarmable" slot-scope="value">
                    <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'使能':'禁用'}}</a-tag>
                  </span>
<!--                  <span slot="alarmtofault" slot-scope="value">-->
<!--                    <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'使能':'禁用'}}</a-tag>-->
<!--                  </span>-->
                  <span slot="lingeringable" slot-scope="value">
                    <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'使能':'禁用'}}</a-tag>
                  </span>
                  <span slot="tiringable" slot-scope="value">
                    <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'使能':'禁用'}}</a-tag>
                  </span>
                  <span slot="vehicleable" slot-scope="value">
                    <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'使能':'禁用'}}</a-tag>
                  </span>
                  <span slot="facevisible" slot-scope="value">
                    <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'使能':'禁用'}}</a-tag>
                  </span>
                  <span slot="facefunction" slot-scope="value">
                    <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'使能':'禁用'}}</a-tag>
                  </span>
                  <span slot="operation" slot-scope="value, record">
                    <a-button type="link" size="small" @click="updateArea(record,value)">禁用</a-button>
                  </span>
                </a-table>
                <a-pagination v-model="currentPage" :total="pagination.total" :page-size="pagination.pageSize" show-size-changer @change="pageChange" @showSizeChange="onShowSizeChange" :show-total="(total, range) => `共${total}条`" style="margin-top: 20px; text-align: right;">
                  <template slot="buildOptionText" slot-scope="props">
                    <span>{{ props.value }}条/页</span>
                  </template>
                </a-pagination>
                  </div>
            </div>
          </a-tab-pane>
            <a-tab-pane key="2" tab="区域使能参数">
              <div class="main-container">
                <div class="right-tabs">
                  <a-form-model ref="modalForm" layout="inline" class="form-in-twocolumns" :label-col="{span:9}" :wrapper-col="{span:14}">
                    <a-form-model-item label="所处区域" prop="areacode">
                      <a-cascader :field-names="{ label: 'areaname', value: 'areacode', children: 'children' }" :options="areaOptions" v-model="areaCascaderSelected" :load-data="areaOnLoadChildren" placeholder="请选择区域" :change-on-select="true" :allow-clear="false"></a-cascader>
                    </a-form-model-item>
                    <a-form-model-item label="救援固定电话" prop="telephone">
                      <a-input v-model="telephone" placeholder="请输入救援固定电话"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="短信使能" prop="messageable">
                      <a-input v-model="messageable" placeholder="1-使能，0-禁用，默认为0"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="应急救援工单使能" prop="rescueable">
                      <a-input v-model="rescueable" placeholder="1-使能，0-禁用，默认为0"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="app应急救援工单" prop="apporderable">
                      <a-input v-model="apporderable" placeholder="1-使能，0-禁用，默认为0"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="一键报警工单联动" prop="alarmable">
                      <a-input v-model="alarmable" placeholder="1-使能，0-禁用，默认为0"></a-input>
                    </a-form-model-item>
                    <!--                  <a-form-model-item label="困人故障转化" prop="alarmtofault">-->
                    <!--                    <a-input v-model="alarmtofault" placeholder="1-使能，0-禁用，默认为0"></a-input>-->
                    <!--                  </a-form-model-item>-->
                    <a-form-model-item label="困人故障短信联动使能" prop="tiringable">
                      <a-input v-model="tiringable" placeholder="1-使能，0-禁用，默认为0"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="轿厢有人长时间驻留短信联动使能" prop="lingeringable">
                      <a-input v-model="lingeringable" placeholder="1-使能，0-禁用，默认为0"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="人脸识别可见使能" prop="facevisible">
                      <a-input v-model="facevisible" placeholder="1-使能，0-禁用，默认为0"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="人脸识别功能使能" prop="facefunction">
                      <a-input v-model="facefunction" placeholder="1-使能，0-禁用，默认为0"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="电瓶车进入轿厢短信联动使能" prop="vehicleable">
                      <a-input v-model="vehicleable" placeholder="1-使能，0-禁用，默认为0"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="一键生成报告机构名称" prop="areadatacenter">
                      <a-input v-model="areadatacenter" placeholder=""></a-input>
                    </a-form-model-item>
                  </a-form-model>
                  <div style="text-align: center">
                    <a-button type="primary" style="margin-top: 1%;margin-bottom: 1%" @click="getAreaParam">参数查询</a-button>
                    <a-button type="primary" style="margin-top: 1%;margin-bottom: 1%;margin-left: 1%" @click="areaParam">参数下发</a-button>
                  </div>
                </div>
              </div>
            </a-tab-pane>

<!--          <a-tab-pane key="2" tab="维保单位使能">-->
<!--            <div class="main-container">-->
<!--              <div class="left-tabs">-->
<!--                <div class="table-header">-->
<!--                  <h3 class="table-title">维保单位使能</h3>-->
<!--                  <div class="table-btns">-->
<!--                    <a-icon type="redo" class="after-btn table-refresh" @click="getUserdepTableData(true,3)"></a-icon>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <a-table :columns="tableColumns1" :data-source="tableData" row-key="userdepid" :loading="tableLoading" :row-class-name="(record, index) => (index%2==0?'table-row-even':'table-row-single')" style="margin-top: 20px;" :pagination="false">-->
<!--                  <span slot="rescueable" slot-scope="value">-->
<!--                    <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'使能':'禁用'}}</a-tag>-->
<!--                  </span>-->
<!--                  <span slot="apporderable" slot-scope="value">-->
<!--                    <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'使能':'禁用'}}</a-tag>-->
<!--                  </span>-->
<!--                  <span slot="messageable" slot-scope="value">-->
<!--                    <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'使能':'禁用'}}</a-tag>-->
<!--                  </span>-->
<!--                  <span slot="alarmable" slot-scope="value">-->
<!--                    <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'使能':'禁用'}}</a-tag>-->
<!--                  </span>-->
<!--                  <span slot="operation" slot-scope="value, record">-->
<!--                    <a-button type="link" size="small" @click="updateUserdep(record,value)">禁用</a-button>-->
<!--                  </span>-->
<!--                </a-table>-->
<!--                <a-pagination v-model="currentPage" :total="pagination.total" :page-size="pagination.pageSize" show-size-changer @change="pageChange" @showSizeChange="onShowSizeChange" :show-total="(total, range) => `共${total}条`" style="margin-top: 20px; text-align: right;">-->
<!--                  <template slot="buildOptionText" slot-scope="props">-->
<!--                    <span>{{ props.value }}条/页</span>-->
<!--                  </template>-->
<!--                </a-pagination>-->
<!--              </div>-->
<!--              <div class="right-tabs">-->
<!--                <a-form-model ref="modalForm" layout="inline" class="form-in-twocolumns" :label-col="{span:9}" :wrapper-col="{span:14}">-->
<!--                  <a-form-model-item v-if="userInfo.usertype=='0'||userInfo.usertype=='3'" label="维保单位" prop="maintenancedepid">-->
<!--                    <a-cascader :field-names="{ label: 'userdepname', value: 'userdepid', children: 'children' }" :options="deptOptions.filter(item => item.deptype=='3')" v-model="maintenancedepidCascaderSelected" :load-data="deptOnLoadChildren" placeholder="请选择维保单位" :change-on-select="true" :allow-clear="false"></a-cascader>-->
<!--                  </a-form-model-item>-->
<!--                  <a-form-model-item label="短信使能" prop="mmessageable">-->
<!--                    <a-input v-model="mmessageable" placeholder="1-使能，0-禁用，默认为0"></a-input>-->
<!--                  </a-form-model-item>-->
<!--                  <a-form-model-item label="应急救援工单使能" prop="mrescueable">-->
<!--                    <a-input v-model="mrescueable" placeholder="1-使能，0-禁用，默认为0"></a-input>-->
<!--                  </a-form-model-item>-->
<!--                  <a-form-model-item label="app应急救援工单" prop="mapporderable">-->
<!--                    <a-input v-model="mapporderable" placeholder="1-使能，0-禁用，默认为0"></a-input>-->
<!--                  </a-form-model-item>-->
<!--                </a-form-model>-->
<!--                <div style="text-align: center">-->
<!--                  <a-button type="primary" style="margin-top: 1%;margin-bottom: 1%" @click="maintenancedepParam">参数配置</a-button>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </a-tab-pane>-->
<!--          <a-tab-pane key="3" tab="使用单位使能">-->
<!--            <div class="main-container">-->
<!--              <div class="left-tabs">-->
<!--                <div class="table-header">-->
<!--                  <h3 class="table-title">使用单位使能</h3>-->
<!--                  <div class="table-btns">-->
<!--                    <a-icon type="redo" class="after-btn table-refresh" @click="getUserdepTableData(true,1)"></a-icon>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <a-table :columns="tableColumns1" :data-source="tableData" row-key="userdepid" :loading="tableLoading" :row-class-name="(record, index) => (index%2==0?'table-row-even':'table-row-single')" style="margin-top: 20px;" :pagination="false">-->
<!--                  <span slot="rescueable" slot-scope="value">-->
<!--                    <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'使能':'禁用'}}</a-tag>-->
<!--                  </span>-->
<!--                  <span slot="apporderable" slot-scope="value">-->
<!--                    <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'使能':'禁用'}}</a-tag>-->
<!--                  </span>-->
<!--                  <span slot="messageable" slot-scope="value">-->
<!--                    <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'使能':'禁用'}}</a-tag>-->
<!--                  </span>-->
<!--                  <span slot="alarmable" slot-scope="value">-->
<!--                    <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'使能':'禁用'}}</a-tag>-->
<!--                  </span>-->
<!--                  <span slot="operation" slot-scope="value, record">-->
<!--                    <a-button type="link" size="small" @click="updateUserdep(record,value)">禁用</a-button>-->
<!--                  </span>-->
<!--                </a-table>-->
<!--                <a-pagination v-model="currentPage" :total="pagination.total" :page-size="pagination.pageSize" show-size-changer @change="pageChange" @showSizeChange="onShowSizeChange" :show-total="(total, range) => `共${total}条`" style="margin-top: 20px; text-align: right;">-->
<!--                  <template slot="buildOptionText" slot-scope="props">-->
<!--                    <span>{{ props.value }}条/页</span>-->
<!--                  </template>-->
<!--                </a-pagination>-->
<!--              </div>-->
<!--              <div class="right-tabs">-->
<!--                <a-form-model ref="modalForm" layout="inline" class="form-in-twocolumns" :label-col="{span:9}" :wrapper-col="{span:14}">-->
<!--                  <a-form-model-item v-if="userInfo.usertype=='0'||userInfo.usertype=='3'" label="使用单位" prop="userdepid">-->
<!--                    <a-cascader :field-names="{ label: 'userdepname', value: 'userdepid', children: 'children' }" :options="deptOptions.filter(item => item.deptype=='1')" v-model="userdepidCascaderSelected" :load-data="deptOnLoadChildren" placeholder="请选择使用单位" :change-on-select="true" :allow-clear="false"></a-cascader>-->
<!--                  </a-form-model-item>-->
<!--                  <a-form-model-item label="短信使能" prop="messageable">-->
<!--                    <a-input v-model="umessageable" placeholder="1-使能，0-禁用，默认为0"></a-input>-->
<!--                  </a-form-model-item>-->
<!--                  <a-form-model-item label="应急救援工单使能" prop="rescueable">-->
<!--                    <a-input v-model="urescueable" placeholder="1-使能，0-禁用，默认为0"></a-input>-->
<!--                  </a-form-model-item>-->
<!--                  <a-form-model-item label="app应急救援工单" prop="apporderable">-->
<!--                    <a-input v-model="uapporderable" placeholder="1-使能，0-禁用，默认为0"></a-input>-->
<!--                  </a-form-model-item>-->
<!--                </a-form-model>-->
<!--                <div style="text-align: center">-->
<!--                  <a-button type="primary" style="margin-top: 1%;margin-bottom: 1%" @click="userdepParam">参数配置</a-button>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </a-tab-pane>-->

        </a-tabs>
    </div>
    </page-container>
  </div>
</template>
<script>
import {findParamsListByCondition, findParamsListByConditions, modifyParams} from "A/xtpz";
import {getCache} from "U/index";
import areaselect from '@/mixins/areaselect'
import deptselect from "@/mixins/deptselect";
import {mapState} from "vuex";
import {getUserdepListByCondition, modifyUserdep} from "A/jcgn";
import pagination from '@/mixins/pagination'
export default {
  name: "paramset",
  mixins: [areaselect, deptselect,pagination],
  data() {
    return {
      breadcrumb: [
        {
          name: '通用设置',
          path: ''
        },
        {
          name: '平台参数',
          path: ''
        },
        {
          name: '平台使能参数',
          path: ''
        },
      ],
      status:false,
      areaable:false,
      usersid:'',
      areacode:'',
      areacodes:'',
      //区域使能参数
      paramsid:'',
      messageable:'',
      apporderable:'',
      rescueable:'',
      telephone:'',
      alarmable:'',
      alarmtofault:'',
      lingeringable:'',
      tiringable:'',
      vehicleable:'',
      areadatacenter:'',
      facevisible:'',
      facefunction:'',
      //使用单位使能参数
      userdepid:'',
      umessageable:'',
      uapporderable:'',
      urescueable:'',
      userdepidCascaderSelected: [],
      //维保单位使能参数
      maintenancedepid:'',
      mmessageable:'',
      mapporderable:'',
      mrescueable:'',
      maintenancedepidCascaderSelected: [],

      //表格
      tableColumns: [
        {
          title: '区域',
          dataIndex: 'areaname',
          key: 'areaname',
          ellipsis: true,
          width:60,
          align: "center"
        },
        {
          title: '应急救援工单',
          dataIndex: 'rescueable',
          key: 'rescueable',
          ellipsis: true,
          width: 110,
          align: "center",
          scopedSlots: { customRender: 'rescueable' }
        },
        {
          title: 'APP救援工单',
          dataIndex: 'apporderable',
          key: 'apporderable',
          ellipsis: true,
          align: "center",
          width: 110,
          scopedSlots: { customRender: 'apporderable' }
        },
        {
          title: '短信',
          dataIndex: 'messageable',
          key: 'messageable',
          ellipsis: true,
          align: "center",
          width: 50,
          scopedSlots: { customRender: 'messageable' }
        },
        {
          title: '一键报警',
          dataIndex: 'alarmable',
          key: 'alarmable',
          ellipsis: true,
          align: "center",
          width: 80,
          scopedSlots: { customRender: 'alarmable' }
        },
        // {
        //   title: '困人故障转化',
        //   dataIndex: 'alarmtofault',
        //   key: 'alarmtofault',
        //   ellipsis: true,
        //   align: "center",
        //   scopedSlots: { customRender: 'alarmtofault' }
        // },
        {
          title: '困人故障短信联动使能',
          dataIndex: 'tiringable',
          key: 'tiringable',
          ellipsis: true,
          align: "center",
          scopedSlots: { customRender: 'tiringable' }
        },
        {
          title: '轿厢有人长时间驻留短信联动使能',
          dataIndex: 'lingeringable',
          key: 'lingeringable',
          ellipsis: true,
          align: "center",
          scopedSlots: { customRender: 'lingeringable' }
        },
        {
          title: '电瓶车进入轿厢短信联动使能',
          dataIndex: 'vehicleable',
          key: 'vehicleable',
          ellipsis: true,
          align: "center",
          scopedSlots: { customRender: 'vehicleable' }
        },
        {
          title: '人脸识别可见使能',
          dataIndex: 'facevisible',
          key: 'facevisible',
          ellipsis: true,
          align: "center",
          scopedSlots: { customRender: 'facevisible' }
        },
        {
          title: '人脸识别功能使能',
          dataIndex: 'facefunction',
          key: 'facefunction',
          ellipsis: true,
          align: "center",
          scopedSlots: { customRender: 'facefunction' }
        },
        // {
        //   title: '区域大数据中心',
        //   dataIndex: 'areadatacenter',
        //   key: 'areadatacenter',
        //   ellipsis: true,
        //   align: "center",
        // },
        {
          title: '操作',
          key: 'operation',
          width: 60,
          align: 'center',
          scopedSlots: { customRender: 'operation' }
        },
      ],
      tableData: [],
      tableLoading: false,
      counts:'0',
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    }),
  },
  watch: {
    areaCascaderSelected(val) {
      if(val && val.length) {
        this.areacode = val[val.length-1];
        this.$refs.modalForm.clearValidate('areacode')
      }else {
        this.formDatas.areacode = '';
      }
    },
    userdepidCascaderSelected(val) {
      if(val && val.length) {
        this.userdepid = val[val.length-1];
        this.$refs.modalForm.clearValidate('userdepid')
      }else{
        this.userdepid = '';
      }
    },
    maintenancedepidCascaderSelected(val) {
      if(val && val.length) {
        this.maintenancedepid = val[val.length-1];
        this.$refs.modalForm.clearValidate('maintenancedepid')
      }else {
        this.maintenancedepid = '';
      }
    },
  },
  created() {
    this.init();
  },
  methods: {
    callback(key) {
      if(key==1){
        this.getTableData(true)
      }else if(key==2){
        this.getUserdepTableData(true,3)
      }else if(key==3){
        this.getUserdepTableData(true,1)
      }
    },
    init() {
      let logininfo = getCache('logininfo', true);
      if (logininfo) {
        // console.log(logininfo)
        this.usersid = logininfo.usersid
        if (this.usersid == 1) {
          this.areaable = true
          this.areacode = ''
        }
      }
      this.getTableData(true)
    },
    updateArea(record,value){
      var that=this
      console.log(record.areacode)
      findParamsListByCondition({areacode: record.areacode}).then(res => {
        if (res && res.returncode == '0') {
          if (record.areacode.length == 2) {
            findParamsListByCondition({grandparentid: res.item[0].paramsid}).then(res => {
              if (res && res.returncode == '0') {
                for (var i = 0; i < res.item.length; i++) {
                  let params = {
                    paramsid: res.item[i].paramsid,
                    messageable: 0,
                    apporderable: 0,
                    rescueable: 0,
                    alarmable:0,
                    vehicleable:0,
                    alarmtofault:0,
                    lingeringable:0,
                    tiringable:0,
                    facevisible:0,
                    facefunction:0
                  }
                  modifyParams(params)
                }
              }
            })
          } else if (record.areacode.length == 4) {
            findParamsListByCondition({parentid: res.item[0].paramsid}).then(res => {
              if (res && res.returncode == '0') {
                for (var i = 0; i < res.item.length; i++) {
                  let params = {
                    paramsid: res.item[i].paramsid,
                    messageable: 0,
                    apporderable: 0,
                    rescueable: 0,
                    alarmable:0,
                    vehicleable:0,
                    alarmtofault:0,
                    lingeringable:0,
                    tiringable:0,
                    facevisible:0,
                    facefunction:0
                  }
                  modifyParams(params)
                }
              }
            })
          }else {
            let params = {
              paramsid: res.item[0].paramsid,
              messageable: 0,
              apporderable: 0,
              rescueable: 0,
              alarmable:0,
              vehicleable:0,
              alarmtofault:0,
              lingeringable:0,
              tiringable:0,
              facevisible:0,
              facefunction:0
            }
            modifyParams(params).then(res=>{
              if (res && res.returncode == '0') {
                this.getTableData(true)
              }
            })
          }
        }
      })
      setTimeout(function () {
        that.getTableData(true)
      }, 1000);
    },
    updateUserdep(record,value){
      var that=this
      if(record.levelid==1||record.levelid==29) {
        modifyUserdep({
          userdepid: record.userdepid,
          deptype: record.deptype,
          userdepname: record.userdepname,
          levelid: record.levelid,
          messageable: 0,
          apporderable: 0,
          rescueable: 0
        })
        getUserdepListByCondition({parentid: record.userdepid}).then(res => {
          if (res && res.returncode == '0') {
            for (var i = 0; i < res.item.length; i++) {
              modifyUserdep({
                userdepid: res.item[i].userdepid,
                deptype: res.item[i].deptype,
                userdepname: res.item[i].userdepname,
                levelid: res.item[i].levelid,
                messageable: 0,
                apporderable: 0,
                rescueable: 0
              })
              getUserdepListByCondition({parentid: res.item[i].userdepid}).then(res => {
                if (res && res.returncode == '0') {
                  for (var i = 0; i < res.item.length; i++) {
                    modifyUserdep({
                      userdepid: res.item[i].userdepid,
                      deptype: res.item[i].deptype,
                      userdepname: res.item[i].userdepname,
                      levelid: res.item[i].levelid,
                      messageable: 0,
                      apporderable: 0,
                      rescueable: 0
                    })
                  }
                }
              })
            }
          }
        })
      }else if(record.levelid==10||record.levelid==30){
        modifyUserdep({
          userdepid: record.userdepid,
          deptype: record.deptype,
          userdepname: record.userdepname,
          levelid: record.levelid,
          messageable: 0,
          apporderable: 0,
          rescueable: 0
        })
        getUserdepListByCondition({parentid: record.userdepid}).then(res => {
          if (res && res.returncode == '0') {
            for (var i = 0; i < res.item.length; i++) {
              modifyUserdep({
                userdepid: res.item[i].userdepid,
                deptype: res.item[i].deptype,
                userdepname: res.item[i].userdepname,
                levelid: res.item[i].levelid,
                messageable: 0,
                apporderable: 0,
                rescueable: 0
              })
            }
          }
        })
      }else{
        modifyUserdep({
          userdepid: record.userdepid,
          deptype: record.deptype,
          userdepname: record.userdepname,
          levelid: record.levelid,
          messageable: 0,
          apporderable: 0,
          rescueable: 0,
          alarmtofault:0,
        })
      }
      setTimeout(function () {
        that.getUserdepTableData(true,record.deptype)
      }, 1000);
    },
    areaParam() {
      var that=this
      if (this.areaCascaderSelected.length == 1) {
        findParamsListByCondition({areacode: this.areaCascaderSelected[this.areaCascaderSelected.length - 1]}).then(res => {
          if (res && res.returncode == '0') {
            findParamsListByCondition({grandparentid: res.item[0].paramsid}).then(res => {
              if (res && res.returncode == '0') {
                for (var i = 0; i < res.item.length; i++) {
                  let params = {
                    paramsid: res.item[i].paramsid,
                    messageable: this.messageable,
                    apporderable: this.apporderable,
                    rescueable: this.rescueable,
                    telephone: this.telephone,
                    alarmable:this.alarmable,
                    alarmtofault:this.alarmtofault,
                    lingeringable:this.lingeringable,
                    tiringable:this.tiringable,
                    vehicleable:this.vehicleable,
                    areadatacenter:this.areadatacenter,
                    facevisible:this.facevisible,
                    facefunction:this.facefunction
                  }
                  modifyParams(params)
                }
              }
            })
          }
        })
      } else if (this.areaCascaderSelected.length == 2) {
        var len;
        findParamsListByCondition({areacode: this.areaCascaderSelected[this.areaCascaderSelected.length - 1]}).then(res => {
          if (res && res.returncode == '0') {
            findParamsListByCondition({parentid: res.item[0].paramsid}).then(res => {
              if (res && res.returncode == '0') {
                for (var i = 0; i < res.item.length; i++) {
                  len = res.item.length - 1;
                  let params = {
                    paramsid: res.item[i].paramsid,
                    messageable: this.messageable,
                    apporderable: this.apporderable,
                    rescueable: this.rescueable,
                    telephone: this.telephone,
                    alarmable:this.alarmable,
                    alarmtofault:this.alarmtofault,
                    lingeringable:this.lingeringable,
                    tiringable:this.tiringable,
                    vehicleable:this.vehicleable,
                    areadatacenter:this.areadatacenter,
                    facevisible:this.facevisible,
                    facefunction:this.facefunction
                  }
                  modifyParams(params)
                }
              }
            })
          }
        })
      } else {
        findParamsListByCondition({areacode: this.areaCascaderSelected[this.areaCascaderSelected.length - 1]}).then(res => {
          if (res && res.returncode == '0') {
            let params = {
              paramsid: res.item[0].paramsid,
              messageable: this.messageable,
              apporderable: this.apporderable,
              rescueable: this.rescueable,
              telephone: this.telephone,
              alarmable:this.alarmable,
              alarmtofault:this.alarmtofault,
              lingeringable:this.lingeringable,
              tiringable:this.tiringable,
              vehicleable:this.vehicleable,
              areadatacenter:this.areadatacenter,
              facevisible:this.facevisible,
              facefunction:this.facefunction
            }
            modifyParams(params).then(res => {
              if (res && res.returncode == '0') {
                this.$message.success("参数配置成功")
              } else {
                this.$message.error("参数配置失败")
              }
            })
          }
        })
      }
      setTimeout(function () {
        that.getTableData(true)
      }, 1500);
    },
    getAreaParam(){
      findParamsListByCondition({areacode: this.areacode}).then(res => {
        if (res && res.returncode == '0') {
          this.messageable=res.item[0].messageable;
          this.apporderable=res.item[0].apporderable;
          this.rescueable=res.item[0].rescueable;
          this.alarmable=res.item[0].alarmable;
          this.telephone=res.item[0].telephone;
          this.alarmtofault=res.item[0].alarmtofault;
          this.lingeringable=res.item[0].lingeringable;
          this.vehicleable=res.item[0].vehicleable;
          this.tiringable=res.item[0].tiringable;
          this.areadatacenter=res.item[0].areadatacenter;
          this.facevisible=res.item[0].facevisible;
          this.facefunction=res.item[0].facefunction;
        }
      })
    },
    userdepParam() {
      var that=this
      if (this.userdepidCascaderSelected.length == 1) {
        console.log(this.userdepidCascaderSelected[this.userdepidCascaderSelected.length - 1])
        getUserdepListByCondition({userdepid:this.userdepidCascaderSelected[this.userdepidCascaderSelected.length - 1]}).then(res => {
          if (res && res.returncode == '0') {
            modifyUserdep({
              userdepid: res.item[0].userdepid,
              deptype: res.item[0].deptype,
              userdepname: res.item[0].userdepname,
              levelid: res.item[0].levelid,
              messageable: this.umessageable,
              apporderable: this.uapporderable,
              rescueable: this.urescueable
            })
          }
        })
        let params = {
          parentid: this.userdepidCascaderSelected[this.userdepidCascaderSelected.length - 1]
        }
        getUserdepListByCondition(params).then(res => {
          if (res && res.returncode == '0') {
            console.log(res.item)
            for (var i = 0; i < res.item.length; i++) {
              modifyUserdep({
                userdepid: res.item[i].userdepid,
                deptype: res.item[i].deptype,
                userdepname: res.item[i].userdepname,
                levelid: res.item[i].levelid,
                messageable: this.umessageable,
                apporderable: this.uapporderable,
                rescueable: this.urescueable
              })
              getUserdepListByCondition({parentid: res.item[i].userdepid}).then(res => {
                if (res && res.returncode == '0') {
                  for (var i = 0; i < res.item.length; i++) {
                    modifyUserdep({
                      userdepid: res.item[i].userdepid,
                      deptype: res.item[i].deptype,
                      userdepname: res.item[i].userdepname,
                      levelid: res.item[i].levelid,
                      messageable: this.umessageable,
                      apporderable: this.uapporderable,
                      rescueable: this.urescueable
                    })
                  }
                }
              })
            }
          }
        })
      } else if (this.userdepidCascaderSelected.length == 2) {
        getUserdepListByCondition({userdepid: this.userdepidCascaderSelected[1]}).then(res => {
          if (res && res.returncode == '0') {
            modifyUserdep({
              userdepid: res.item[0].userdepid,
              deptype: res.item[0].deptype,
              userdepname: res.item[0].userdepname,
              levelid: res.item[0].levelid,
              messageable: this.umessageable,
              apporderable: this.uapporderable,
              rescueable: this.urescueable
            })
          }
        })
        let params = {
          parentid: this.userdepidCascaderSelected[this.userdepidCascaderSelected.length - 1]
        }
        getUserdepListByCondition(params).then(res => {
          if (res && res.returncode == '0') {
            console.log(res.item)
            for (var i = 0; i < res.item.length; i++) {
              modifyUserdep({
                userdepid: res.item[i].userdepid,
                deptype: res.item[i].deptype,
                userdepname: res.item[i].userdepname,
                levelid: res.item[i].levelid,
                messageable: this.umessageable,
                apporderable: this.uapporderable,
                rescueable: this.urescueable
              })
            }
          }
        })
      } else {
        let params = {
          userdepid: this.userdepidCascaderSelected[this.userdepidCascaderSelected.length - 1]
        }
        getUserdepListByCondition(params).then(res => {
          if (res && res.returncode == '0') {
            console.log(res.item)
            modifyUserdep({
              userdepid: res.item[0].userdepid,
              deptype: res.item[0].deptype,
              userdepname: res.item[0].userdepname,
              levelid: res.item[0].levelid,
              messageable: this.umessageable,
              apporderable: this.uapporderable,
              rescueable: this.urescueable
            }).then(res => {
              if (res && res.returncode == '0') {
                this.$message.success("参数配置成功")
              } else {
                this.$message.success("参数配置失败")
              }
            })
          }
        })
      }
      setTimeout(function () {
        that.getUserdepTableData(true,1)
      }, 1000);
    },
    maintenancedepParam() {
      var that=this
      if (this.maintenancedepidCascaderSelected.length == 1) {
        console.log(this.maintenancedepidCascaderSelected[this.maintenancedepidCascaderSelected.length - 1])
        getUserdepListByCondition({userdepid:this.maintenancedepidCascaderSelected[this.maintenancedepidCascaderSelected.length - 1]}).then(res => {
          if (res && res.returncode == '0') {
            modifyUserdep({
              userdepid: res.item[0].userdepid,
              deptype: res.item[0].deptype,
              userdepname: res.item[0].userdepname,
              levelid: res.item[0].levelid,
              messageable: this.mmessageable,
              apporderable: this.mapporderable,
              rescueable: this.mrescueable
            })
          }
        })
        let params = {
          parentid: this.maintenancedepidCascaderSelected[this.maintenancedepidCascaderSelected.length - 1]
        }
        getUserdepListByCondition(params).then(res => {
          if (res && res.returncode == '0') {
            console.log(res.item)
            for (var i = 0; i < res.item.length; i++) {
              modifyUserdep({
                userdepid: res.item[i].userdepid,
                deptype: res.item[i].deptype,
                userdepname: res.item[i].userdepname,
                levelid: res.item[i].levelid,
                messageable: this.mmessageable,
                apporderable: this.mapporderable,
                rescueable: this.mrescueable
              })
              getUserdepListByCondition({parentid: res.item[i].userdepid}).then(res => {
                if (res && res.returncode == '0') {
                  for (var i = 0; i < res.item.length; i++) {
                    modifyUserdep({
                      userdepid: res.item[i].userdepid,
                      deptype: res.item[i].deptype,
                      userdepname: res.item[i].userdepname,
                      levelid: res.item[i].levelid,
                      messageable: this.mmessageable,
                      apporderable: this.mapporderable,
                      rescueable: this.mrescueable
                    })
                  }
                }
              })
            }
          }
        })
      } else if (this.maintenancedepidCascaderSelected.length == 2) {
        getUserdepListByCondition({userdepid: this.maintenancedepidCascaderSelected[1]}).then(res => {
          if (res && res.returncode == '0') {
            modifyUserdep({
              userdepid: res.item[0].userdepid,
              deptype: res.item[0].deptype,
              userdepname: res.item[0].userdepname,
              levelid: res.item[0].levelid,
              messageable: this.mmessageable,
              apporderable: this.mapporderable,
              rescueable: this.mrescueable
            })
          }
        })
        let params = {
          parentid: this.maintenancedepidCascaderSelected[this.maintenancedepidCascaderSelected.length - 1]
        }
        getUserdepListByCondition(params).then(res => {
          if (res && res.returncode == '0') {
            console.log(res.item)
            for (var i = 0; i < res.item.length; i++) {
              modifyUserdep({
                userdepid: res.item[i].userdepid,
                deptype: res.item[i].deptype,
                userdepname: res.item[i].userdepname,
                levelid: res.item[i].levelid,
                messageable: this.mmessageable,
                apporderable: this.mapporderable,
                rescueable: this.mrescueable,
              })
            }
          }
        })
      } else {
        let params = {
          userdepid: this.maintenancedepidCascaderSelected[this.maintenancedepidCascaderSelected.length - 1]
        }
        getUserdepListByCondition(params).then(res => {
          if (res && res.returncode == '0') {
            console.log(res.item)
            modifyUserdep({
              userdepid: res.item[0].userdepid,
              deptype: res.item[0].deptype,
              userdepname: res.item[0].userdepname,
              levelid: res.item[0].levelid,
              messageable: this.mmessageable,
              apporderable: this.mapporderable,
              rescueable: this.mrescueable
            }).then(res => {
              if (res && res.returncode == '0') {
                this.$message.success("参数配置成功")
              } else {
                this.$message.success("参数配置失败")
              }
            })
          }
        })
      }
      setTimeout(function () {
        that.getUserdepTableData(true,3)
      }, 1000);
    },
    getTableData(firstPage) {
      if (firstPage) {
        this.currentPage = 1;
      }
      this.tableLoading = true;
      let params = {
        rescueable:1,
        messageable:1,
        pageno: this.currentPage,
        pagesize: this.pagination.pageSize
      };
      findParamsListByConditions(params).then(res => {
        this.tableLoading = false;
        if (res && res.returncode == '0') {
          this.tableData = res.item;
          this.pagination.total = res.count;
        }
      }).catch(err => {
        this.tableLoading = false;
      })
    },
    getUserdepTableData(firstPage,deptype) {
      if (firstPage) {
        this.currentPage = 1;
      }
      this.tableLoading = true;
      let params = {
        deptype:deptype,
        rescueable:"1",
        pageno: this.currentPage,
        pagesize: this.pagination.pageSize
      };
      getUserdepListByCondition(params).then(res => {
        this.tableLoading = false;
        if (res && res.returncode == '0') {
          this.tableData = res.item;
          this.pagination.total = res.count;
        }
      }).catch(err => {
        this.tableLoading = false;
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.bg-white {
  background-color: #fff;
}
.title {
  font-weight: bold;
  font-size: 20px;
  padding: 5px 20px;
}
.main-container {
  display: flex;
  padding: 10px;
  .right-tabs{
    flex-grow: 1;
    overflow: auto;
    width: 65%;
    height: auto;
    float: right;
    margin-left: 1%;
    padding-top: 1%;
    background-color: white;
    border-radius: 5px;
  }
  .list-table{
    flex-grow: 1;
    overflow: auto;
    width: 100%;
    height: auto;
    float: right;
    margin-left: 1%;
    margin-right: 1%;
    //padding-top: 1%;
    background-color: white;
    border-radius: 5px;
  }
  .left-tabs {
    flex-shrink: 0;
    width: 35%;
    height: auto;
    padding-top: 1.0%;
    background-color: white;
    border-radius: 5px;
    .table-header{
      .table-title {
        float: left;
        margin-left: 2.0%;
        line-height: 32px;
      }
      .table-btns {
        float: right;
        margin-right: 4%;
      }
    }
  }
}
</style>